module.exports = __webpack_public_path__ + "img/NL577.bb522042.png";